import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { createAccountCall } from "api/api";
import Modal from "../../components/modal";

const defaultState = {
  account_number: "",
  holder_name: "",
  initial_reading: "",
  address: "",
  phone_number: "",
  current_balance: "",
  free_units: 0,
  membership_date: "",
  remarks: "",
  initial_reading_date: ""
};
export default function CreateAccountForm({ open, onClose, reload }) {
  const [state, setState] = useState(defaultState);
  const onCreate = async () => {
    if (!state.account_number) {
      return global.showAlert(
        "Validation Errors",
        "Account Number is required to create an account",
        "warning"
      );
    }
    if (!state.holder_name) {
      return global.showAlert(
        "Validation Errors",
        "Account Holder Name is required to create an account",
        "warning"
      );
    }
    if (isNaN(state.free_units) || state.free_units < 0) {
      return global.showAlert(
        "Validation Errors",
        "Free units count should be a valid number",
        "warning"
      );
    }
    if (state.initial_reading === "" || (!state.initial_reading && state.initial_reading != 0)) {
      return global.showAlert(
        "Validation Errors",
        "Initial Meter Reading is required to create an account",
        "warning"
      );
    }
    if (!state.initial_reading_date) {
      return global.showAlert(
        "Validation Errors",
        "Initial Meter Reading Date is required to create an account",
        "warning"
      );
    }
    if (state.current_balance === "" || (!state.current_balance && state.current_balance != 0)) {
      return global.showAlert(
        "Validation Errors",
        "Current Account Balance is required to create an account",
        "warning"
      );
    }
    const {
      account_number,
      holder_name,
      initial_reading,
      address,
      phone_number,
      current_balance,
      free_units,
      membership_date,
      remarks,
      initial_reading_date
    } = state;
    const response = await createAccountCall({
      account_number,
      holder_name,
      initial_reading: Number(initial_reading),
      address,
      phone_number,
      current_balance: Number(current_balance),
      free_units,
      membership_date,
      remarks,
      initial_reading_date,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    setState(defaultState);
  }, [open]);

  return (
    <Modal
      open={open}
      title={"add new account"}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onCreate} variant="gradient" color="info">
            submit
          </MDButton>
          <MDButton onClick={onClose} variant="gradient" color="error">
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Account Number"
            fullWidth
            value={state.account_number}
            onChange={(event) => {
              setState({ ...state, account_number: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Holder Name"
            fullWidth
            value={state.holder_name}
            onChange={(event) => {
              setState({ ...state, holder_name: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Address"
            fullWidth
            value={state.address}
            onChange={(event) => {
              setState({ ...state, address: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Phone Number"
            fullWidth
            value={state.phone_number}
            onChange={(event) => {
              setState({ ...state, phone_number: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="Free Units"
            fullWidth
            value={state.free_units}
            onChange={(event) => {
              setState({ ...state, free_units: Number(event.target.value) });
            }}
            InputProps={{ inputProps: { min: 0 } }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="Initial Meter Reading"
            fullWidth
            value={state.initial_reading}
            onChange={(event) => {
              setState({ ...state, initial_reading: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="date"
            label="Initial Meter Reading Date"
            fullWidth
            value={state.initial_reading_date}
            onChange={(event) => {
              setState({ ...state, initial_reading_date: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="Current Account Balance"
            fullWidth
            value={state.current_balance}
            onChange={(event) => {
              setState({ ...state, current_balance: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="date"
            label="Membership Date"
            fullWidth
            value={state.membership_date}
            onChange={(event) => {
              setState({ ...state, membership_date: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Remarks"
            fullWidth
            value={state.remarks}
            onChange={(event) => {
              setState({ ...state, remarks: event.target.value });
            }}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
}
